import _slicedToArray from "/home/maxwell/maxwell-sms-shopify-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import { TickSmallMinor } from '@shopify/polaris-icons';
import { classNames } from '../../../../utilities/css.js';
import styles from './Checkbox.scss.js';
import { useUniqueId } from '../../../../utilities/unique-id/hooks.js';
import { Icon } from '../../../Icon/Icon.js';

function Checkbox(_ref) {
  var idProp = _ref.id,
      _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      disabled = _ref.disabled,
      active = _ref.active,
      onChange = _ref.onChange,
      name = _ref.name,
      value = _ref.value,
      role = _ref.role;
  var id = useUniqueId('Checkbox', idProp);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      keyFocused = _useState2[0],
      setKeyFocused = _useState2[1];

  var className = classNames(styles.Checkbox, active && styles.active);

  var handleBlur = function handleBlur() {
    setKeyFocused(false);
  };

  var handleKeyUp = function handleKeyUp() {
    !keyFocused && setKeyFocused(true);
  };

  var inputClassName = classNames(styles.Input, keyFocused && styles.keyFocused);
  return (
    /*#__PURE__*/
    React.createElement("div", {
      className: className
    },
    /*#__PURE__*/
    React.createElement("input", {
      id: id,
      name: name,
      value: value,
      type: "checkbox",
      checked: checked,
      disabled: disabled,
      className: inputClassName,
      "aria-checked": checked,
      onChange: onChange,
      onBlur: handleBlur,
      onKeyUp: handleKeyUp,
      role: role
    }),
    /*#__PURE__*/
    React.createElement("div", {
      className: styles.Backdrop
    }),
    /*#__PURE__*/
    React.createElement("div", {
      className: styles.Icon
    },
    /*#__PURE__*/
    React.createElement(Icon, {
      source: TickSmallMinor
    })))
  );
}

export { Checkbox };